module.exports = __webpack_public_path__ + "static/media/chef1.fbfca208.jpg";